module.exports = __webpack_public_path__ + "static/img/pat.m.1b6e713.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/pat.m.jpg
// module id = 284
// module chunks = 382